// «Шиты-экраны»: form sheets, которые на mobile открываются как полноэкранные
// (options.screen). На web это НЕ шиты, а обычные react-router экраны внутри
// мобильного контейнера: у них есть URL, они попадают в history.
// При добавлении нового полноэкранного form sheet: ключ в ScreensList + путь сюда.
import type { NavKey } from '@shared-core/navigation'

export type SheetScreenKey = never

// URL-пути шитов-экранов (все приватные, без таб-бара). Не пересекаются с SCREENS_PATHS.
export const SHEET_SCREEN_PATHS: Record<SheetScreenKey, string> = {}

export function isSheetScreenKey(_key: NavKey): _key is SheetScreenKey {
  return false
}

export const SHEET_SCREEN_PATH_PARAMS: Partial<Record<SheetScreenKey, string | readonly string[]>> = {}

export function sheetScreenPathParamNames(_key: string): string[] {
  return []
}

export function sheetScreenPathParamsAreOptional(_key: string): boolean {
  return false
}

export const publicSheetScreenKeys: SheetScreenKey[] = []

export const sheetScreenKeys = Object.keys(SHEET_SCREEN_PATHS) as SheetScreenKey[]
